import { FunctionComponent, PropsWithChildren, useState } from 'react';
import { ErrorContainer, FormErrorContext, SetError } from './FormErrorContext';

export const FormErrorContextProvider: FunctionComponent<
    PropsWithChildren<unknown>
> = ({ children }) => {
    const [errorContainer, setErrorContainer] = useState<ErrorContainer>({});

    const setError: SetError = (inputFieldName, message) => {
        setErrorContainer((prevErrorContainer) => ({
            ...prevErrorContainer,
            [inputFieldName]: message,
        }));
    };

    const clearErrors = () => {
        setErrorContainer({});
    };

    return (
        <FormErrorContext.Provider
            value={[errorContainer, setError, clearErrors]}
        >
            {children}
        </FormErrorContext.Provider>
    );
};
